export default __webpack_public_path__ + "static/media/icon-manage-services.6a287bcc.svg";